module.exports = __webpack_public_path__ + "img/down_xianlai1.d6084f43.png";